export default "__VITE_ASSET__CJEPYvfM__"